import { AddRounded, DeleteSweepOutlined, LoopRounded } from "@mui/icons-material";
import { Button, ButtonProps } from "@mui/material";
import Typography from "@mui/material/Typography";
import { ReactNode, SyntheticEvent } from "react";
import { MuiIconButton, MuiStack } from "../components";

export interface GroupCatalogHeaderProps {
    onAdd: (e: SyntheticEvent, mode?: string) => void
    onRefresh: ButtonProps['onClick']
    onDelete: ButtonProps['onClick']
    headerLabel?: ReactNode
    addButtonLabel?: ReactNode
    isAssociationButton?: boolean
    isHeaderButton?: boolean
    disableDelete?: boolean
    disableAdd?: boolean
    loading?: boolean
}


export const GroupCatalogHeader = (props: GroupCatalogHeaderProps) => {
    const {
        headerLabel,
        addButtonLabel,
        onAdd,
        isHeaderButton,
        onRefresh,
        disableAdd,
        isAssociationButton,
        onDelete,
        disableDelete,
        loading
    } = props

    const AssociationButtons = () => {
        return (
            <MuiStack justifyContent="space-between">
                {!disableDelete && (
                    <MuiIconButton
                        id="multi-delete"
                        tooltipTitle={"Delete selected"}
                        onClick={onDelete}
                    >
                        <DeleteSweepOutlined color='secondary' />
                    </MuiIconButton>
                )}
                <MuiIconButton
                    id="refresh"
                    tooltipTitle={"Refresh"}
                    onClick={onRefresh}
                >
                    <LoopRounded color='secondary' />
                </MuiIconButton>
                {!disableAdd && (
                    <MuiIconButton
                        id="add"
                        tooltipTitle={"Add"}
                        onClick={(e) => onAdd(e, "add")}
                    >
                        <AddRounded color='secondary' />
                    </MuiIconButton>
                )}
            </MuiStack>
        );
    };

    return (
        <>

            <MuiStack flexDirection='row' justifyContent='space-between' pb={1} >
                <Typography variant="h1">
                    {headerLabel || ''}
                </Typography>
                {isAssociationButton && <AssociationButtons />}
                {isHeaderButton && !isAssociationButton &&
                    <MuiStack justifyContent='end' columnGap={1}>
                        {!disableDelete &&
                            <Button
                                id="multi-delete"
                                variant='outlined'
                                size="small"
                                color='secondary'
                                children={"Delete"}
                                onClick={onDelete}
                            />
                        }
                        <Button
                            id="refresh"
                            onClick={onRefresh}
                            variant='outlined'
                            color='secondary'
                            size='small'
                        >
                            Refresh
                        </Button>
                        {!disableAdd &&
                            <Button
                                id="add"
                                variant="contained"
                                size='small'
                                children={addButtonLabel || "Add Item"}
                                onClick={(e: any) => onAdd(e, "add")}
                            />
                        }
                    </MuiStack>
                }
            </MuiStack>
        </>
    );
};
